import axios from 'axios'
import React, { useState } from 'react'
import authService from '../../../Components/Login/auth.service'
import '../../../styles/pages/MenuDireito/modal/ModalFuncaoEPermissao.css'

export default function ModalFuncaoEPermissao({ setOpenModal, modalInfo }) {
  var user = authService.getCurrentUser()
  function handleInputChange(event) {
    if (event.target.name === 'fncStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
  }
  let newDate = new Date()
  const [campos, setCampos] = useState({
    IdFuncao: modalInfo.IdFuncao,
    IdEmpresa: modalInfo.IdEmpresa,
    fncDescricao: modalInfo.fncDescricao,
    fncObservacoes: modalInfo.fncObservacoes,
    fncStatus: modalInfo.fncStatus,
    fncAlteradoPor: user[0].pesEmail,
    fncAlteradoEm: newDate
  })
  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .put(
        process.env.REACT_APP_API_URL + '/api/v1/funcao/' + campos.IdFuncao,
        campos
      )
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }

  return (
    <div className="modalEquipe">
      <div
        onClick={() => {
          setOpenModal(false)
        }}
        className="overlay"
      ></div>
      <div className="modalPadrao-content">
        <div className="cxTituloPadrao">
          <h1>
            Editar Função
            <hr className="hrTitleModal" />
          </h1>
          <button
            className="close-modal"
            onClick={() => {
              setOpenModal(false)
            }}
          >
            X
          </button>
        </div>
        <form onSubmit={handleFormSubmit}>
          <label>Descrição:</label>
          <input
            type="text"
            id="fname"
            defaultValue={campos.fncDescricao}
            name="fncDescricao"
            onChange={handleInputChange}
          ></input>
          <label>Observações:</label>
          <textarea
            type="text"
            id="fname"
            defaultValue={campos.fncObservacoes}
            name="fncObservacoes"
            onChange={handleInputChange}
            row="none"
            maxLength="500"
          ></textarea>
          <div className="caixaSalvarPadrao">
            <div className="InputAuthorization4">
              <label>
                <input
                  name="txtStatus"
                  type="checkbox"
                  defaultChecked={!!campos.fncStatus}
                  onChange={handleInputChange}
                />
                <span>Status</span>
              </label>
            </div>

            <button type="submit">Salvar Registro</button>
          </div>
        </form>
      </div>
    </div>
  )
}
